import axios from "axios";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { vipRegex } from "../../../utilities/vipTest";
import { API_KEY } from "../../../utilities/apiKey";

const getSeatLayoutBody = (
  MovieProviderID = "601B808F-B369-4F10-A108-E3BF40D9A709",
  ScreenID = "9AA5482A-4210-415D-B7F7-A2A24A00FA41",
  ShowID = "61D88FBF-8B81-40A5-BA40-56E97C3CAFD0"
) => ({
  RequestID: "GETSCREENLAYOUT_V1",
  SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
  Country: "KENYA",
  City: "NAIROBI",
  UserID: "Pesapal",
  Key: "2344",
  MobileNumber: "",
  TrxReference: "123487",
  IMEI: "231766434532535",
  GetMovies: {
    MovieProviderID: MovieProviderID,
    ScreenID: ScreenID,
    ShowID: ShowID,
  },
});

const getSeatLayout = (
  MovieProviderID = "30ABF7A6-A651-48D7-BE66-37E518EF86D7",
  ScreenID = "42947",
  ShowID = "42947"
) =>
  new Promise((resolve, reject) => {
    axios
      .post(apiEndpoint, getSeatLayoutBody(MovieProviderID, ScreenID, ShowID), {
        headers: {
          "X-API-KEY": API_KEY,
        },
      })
      .then((response) => {
        if (response.data[0] && response.data[0].SeatLayout) {
          let ScreenIsVip = false;
          let vipRows = [];
          for (let row of response.data[0].SeatLayout) {
            if (row.SeatDescription && row.SeatDescription.match(vipRegex)) {
              vipRows.push(true);
            } else {
              vipRows.push(false);
            }

            if (row.AllocatedSeats?.length) {
              for (let { SeatNumber } of row.AllocatedSeats) {
                if (!SeatNumber || !SeatNumber?.length) continue;
                const [rowName, position] = SeatNumber.split("");

                if (rowName !== row.RowName) {
                  continue;
                }
                console.log(
                  "Found a row with allocated seats: ",
                  row.RowName,
                  row.RowLayout
                );

                let layout = row.RowLayout.split(",");
                for (let i = 0; i < layout.length; i++) {
                  if (i === position - 1) {
                    layout[i] = "1";
                  }
                }

                row.RowLayout = layout.join(",");

                console.log("New layout: ", row.RowLayout);
              }
            }
          }
          ScreenIsVip = vipRows.every((val) => val);
          resolve([
            response.data[0].SeatLayout,
            response.data[0].Markup ?? 0,
            ScreenIsVip,
          ]);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => reject(error));
  });

export default getSeatLayout;
